<nz-modal
  nzClassName="hill-modal"
  nzWidth="1000px"
  [(nzVisible)]="isVisible"
  (nzOnCancel)="onClose()"
  (nzAfterClose)="onClose()"
  [nzMaskClosable]="true"
  [nzClosable]="true"
  [nzFooter]="null"
  nzKeyboard="false"
  >
  <ng-container *nzModalContent>
    <app-shared-login #loginComponent
      [loginError]="loginError$ | async"
      [isModal]="true"
      (close)="onClose()"
    ></app-shared-login>
  </ng-container>
</nz-modal>